import { forwardRef } from "react";
import Button from "../Button";
import { clearChatLocalStorage } from "../../lib/helper/clearChatLocalStorage";

export const ChatBotEndChat = forwardRef(
  (
    { onEndChat, brandPrimaryColor, handleBackToChat, handleCloseChat, branding },
    ref
  ) => {
    const handleEndChat = () => {
      onEndChat(true);
      handleCloseChat();
      clearChatLocalStorage();
    };

    return (
      <div className="curai-box-border curai-p-5 curai-flex-col curai-h-full curai-w-full curai-flex curai-justify-between">
        <div className=" curai-flex curai-flex-1 curai-flex-col curai-items-start ">
          <div className="curai-mb-2 curai-font-bold curai-text-xl curai-text-left curai-text-black">
            End chat?
          </div>
          <p className="curai-mb-5 curai-text-start curai-text-base curai-text-black">
            Please note, ending the chat will erase the chat history.
          </p>
         {branding?.global?.isEmailTranscriptVisible !== false && (
          <p className="curai-mb-5 curai-text-start curai-text-base curai-text-black">
            To keep a copy, click "Email Icon" at the top before exiting.
          </p>
        )}
        </div>
        <div className="curai-flex curai-justify-between curai-w-full curai-box-border">
          <Button
            variant="tertiary"
            id="curatu-end-go-back-chat"
            className="curai-mr-3 curai-focus:ring-0 curai-focus:ring-transparent "
            color={brandPrimaryColor}
            onClick={handleBackToChat}
            ref={ref}
          >
            Back to Chat
          </Button>
          <Button
            variant="primary"
            color={brandPrimaryColor}
            onClick={handleEndChat}
            id="curatu-confirm-end-chat"
            ref={ref}
          >
            End Chat
          </Button>
        </div>
      </div>
    );
  }
);
